function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["width", "height"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    class: "icon-highlight-color",
    width: $props.dimensions,
    height: $props.dimensions,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _toConsumableArray(_cache[0] || (_cache[0] = [_createElementVNode("path", {
    d: "M23.0288 32.8494L13.8501 36.428L17.4288 27.2494L35.7288 8.84937L41.4288 14.5494L23.0288 32.8494Z",
    "stroke-miterlimit": "10",
    "stroke-linejoin": "round"
  }, null, -1 /* CACHED */), _createElementVNode("path", {
    d: "M17.4287 27.2498L23.0287 32.8498",
    "stroke-miterlimit": "10"
  }, null, -1 /* CACHED */), _createElementVNode("path", {
    d: "M24.1 9.79971C23.4 9.69971 22.7 9.69971 22 9.69971C12.1 9.69971 4 17.7997 4 27.6997C4 37.5997 12.1 45.6997 22 45.6997C31.9 45.6997 40 37.5997 40 27.6997C40 26.7997 39.9 25.7997 39.8 24.9997",
    "stroke-miterlimit": "10"
  }, null, -1 /* CACHED */), _createElementVNode("path", {
    d: "M19.7031 4.00008L24.5827 9.37759L19.5121 14.7599",
    "stroke-miterlimit": "10",
    "stroke-linejoin": "round"
  }, null, -1 /* CACHED */)])), 8 /* PROPS */, _hoisted_1);
}